module.exports = __webpack_public_path__ + "media/images/icon-document-outline-b905e2490001207d00b65dadcfe2b851.svg";